import { useEffect } from "react";

/**
 * Set overflow: hidden on body when one or some popups are open
 */
export const usePopup = (() => {
  let opened = 0;

  return function usePopup(open: boolean, pos?: "X" | "Y") {
    useEffect(() => {
      if (open) {
        opened++;

        if (pos === "X") {
          document.body.style.overflowX = "hidden";
        } else if (pos === "Y") {
          document.body.style.overflowY = "hidden";
        } else {
          document.body.style.overflow = "hidden";
        }

        return () => {
          opened--;
          if (opened === 0) {
            document.body.style.overflow = "auto";
          }
        };
      }
    }, [open, pos]);
  };
})();
